import React from "react";
import Items from "./Items.tsx";

const Dashboard = () => {
  return (
    <div>
      <Items />
    </div>
  );
};

export default Dashboard;
